// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"52547dea","512":"0881c193","558":"623babd6","871":"2bc69f48"}[chunkId] + ".chunk.js";
};